/* eslint-disable */

export const protobufPackage = 'Reality.Reality.Api'

export enum UploadStatus {
  UPLOAD_STATUS_UNKNOWN = 0,
  UPLOAD_STATUS_START = 1,
  UPLOAD_STATUS_COMPLETE = 2,
  UPLOAD_STATUS_FILE_FORMAT_ERROR = 3,
  UPLOAD_STATUS_OTHER_ERROR = 4,
  UNRECOGNIZED = -1,
}

export function uploadStatusFromJSON(object: any): UploadStatus {
  switch (object) {
    case 0:
    case 'UPLOAD_STATUS_UNKNOWN':
      return UploadStatus.UPLOAD_STATUS_UNKNOWN
    case 1:
    case 'UPLOAD_STATUS_START':
      return UploadStatus.UPLOAD_STATUS_START
    case 2:
    case 'UPLOAD_STATUS_COMPLETE':
      return UploadStatus.UPLOAD_STATUS_COMPLETE
    case 3:
    case 'UPLOAD_STATUS_FILE_FORMAT_ERROR':
      return UploadStatus.UPLOAD_STATUS_FILE_FORMAT_ERROR
    case 4:
    case 'UPLOAD_STATUS_OTHER_ERROR':
      return UploadStatus.UPLOAD_STATUS_OTHER_ERROR
    case -1:
    case 'UNRECOGNIZED':
    default:
      return UploadStatus.UNRECOGNIZED
  }
}

export function uploadStatusToJSON(object: UploadStatus): string {
  switch (object) {
    case UploadStatus.UPLOAD_STATUS_UNKNOWN:
      return 'UPLOAD_STATUS_UNKNOWN'
    case UploadStatus.UPLOAD_STATUS_START:
      return 'UPLOAD_STATUS_STARTED'
    case UploadStatus.UPLOAD_STATUS_COMPLETE:
      return 'UPLOAD_STATUS_COMPLETE'
    case UploadStatus.UPLOAD_STATUS_FILE_FORMAT_ERROR:
      return 'UPLOAD_STATUS_FILE_FORMAT_ERROR'
    case UploadStatus.UPLOAD_STATUS_OTHER_ERROR:
      return 'UPLOAD_STATUS_ERROR'
    case UploadStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}
